import { FieldValues } from "react-hook-form";
import { IInspectionAttempt, IVerticalTabProps } from "@miplatform/types";

export const getOrderTypeFilterTabs = <T extends FieldValues>(
  inspections: IInspectionAttempt[]
) => {
  const uniqueTemplateIds = new Set<string>();
  const filterOptions: IVerticalTabProps<T>[] = [];

  inspections.forEach((inspection) => {
    if (!uniqueTemplateIds.has(inspection.templateId)) {
      uniqueTemplateIds.add(inspection.templateId);
      filterOptions.push({
        label: inspection.templateName,
        value: inspection.templateId,
        ...inspection,
      });
    }
  });

  return filterOptions;
};
